import React from "react";
import { ClearAllProps } from "@usereactify/search";

export type ClearAllPropsComponent = React.ComponentProps<
  NonNullable<ClearAllProps["render"]>
> & {
  text?: string;
};

export const ClearAll: React.FC<ClearAllPropsComponent> = (props) => {
  return <a onClick={props.clearAll}>{props?.text ? props?.text : "Clear All"}</a>;
};
